import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import HoverButton from "../HoverButton";
import suiteImage1 from "../../assets/TropicalSuiteImg/TS16.jpg";
import suiteImage2 from "../../assets/EarthenSuiteImg/ES14.jpg";
import EastIconArrow from "../../assets/east.svg";

import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
const AmberOtherSuites = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const isSmall = useMediaQuery("(max-width:700px)");
  const navigate = useNavigate();

  const styles = {
    container: {
      width: isMobile ? "90%" : "90%",
      maxWidth: "100%",
      boxSizing: "border-box",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: isMobile ? "5px" : "40px",
      marginBottom: isMobile ? "20px" : "80px",
    },
    heading: {
      fontFamily: "ZapfHumnst BT",
      fontSize: { xs: "20px", sm: "20px", md: "28px", lg: "36px", xl: "40px" },
      fontWeight: 400,
      lineHeight: isMobile ? "36px" : "44.56px",
      letterSpacing: "0.05em",
      textAlign: "center",
    },
    suiteContainer: {
      display: "flex",
      flexDirection: isSmall ? "column" : "row", // Change to column for small screens
      justifyContent: "center",
      gap: isMobile ? "18px" : "40px",
      marginTop: "40px",
    },
    suiteCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: isSmall ? "flex-start" : "center", // Align items to the left
      gap: "2%",
      marginTop: "20px",
      width: isMobile ? "100%" : "70%",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    imageContainer: {
      width: "100%",
      height: "90%",
      borderRadius: {
        xs: "300px 300px 0px 0px",
        sm: "300px 300px 0px 0px",
        md: "300px 300px 0px 0px",
        lg: "370px 370px 0px 0px",
        xl: "450px 450px 0px 0px",
      },
      overflow: "hidden",
    },
    textWrapper: {
      width: isSmall ? "100%" : "95%",
      textAlign: "center",
    },
    textWrapper2: {
      marginTop: isMobile ? "10px" : "20px",
      textAlign: "center",
    },
    title: {
      fontFamily: "ZapfHumnst BT",
      fontSize: { xs: "32px", sm: "32px", md: "27px", lg: "31px", xl: "40px" },
      fontWeight: 400,
      lineHeight: isMobile ? "39.61px" : "91.6px",
      letterSpacing: "0.05em",
      textAlign: isSmall ? "left" : "center", // Change to column for small screens
    },
    subheading: {
      fontFamily: "Sora",
      fontSize: { xs: "14px", sm: "14px", md: "14px", lg: "16px", xl: "20px" },
      fontWeight: 300,
      lineHeight: isMobile ? "16px" : "26px",
      letterSpacing: "0.01em",
      textAlign: isSmall ? "left" : "center", // Change to column for small screens
      color: "#4D4D4D",
      paddingBottom: "15px",
    },
    button: {
      display: "inline-flex",
      alignItems: "center",
      gap: isMobile ? "5px" : "8px",
      backgroundColor: "transparent",
      border: "1px solid #000",
      padding: isMobile ? "5px 6px" : "8px 12px",
      cursor: "pointer",
      color: "#442A0B",
      borderRadius: "0px",
      width: isMobile ? "106px" : "132px",
      height: isMobile ? "40px" : "50px",
      fontSize: { xs: "10px", sm: "14px", md: "14px", lg: "16px", xl: "16px" },
      boxShadow: "none",
      "& .MuiButton-label": {
        fontFamily: "Sora",
        fontSize: {
          xs: "10px",
          sm: "14px",
          md: "14px",
          lg: "16px",
          xl: "16px",
        },
        fontWeight: 400,
        lineHeight: isMobile ? "16px" : "26px",
        letterSpacing: "0.01em",
        textAlign: "left",
        color: "#000",
      },
    },
    icon: {
      width: isMobile ? "18px" : "24px",
      height: isMobile ? "18px" : "24px",
      transform: "rotate(305deg)",
    },
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.heading}>OTHER SUITES</Typography>
      <Box sx={styles.suiteContainer}>
        <Box sx={styles.suiteCard}>
          <Box sx={styles.imageContainer}>
            <img src={suiteImage1} alt="Suite 1" style={styles.image} />
          </Box>
          <Box sx={styles.textWrapper}>
            <Typography sx={styles.title}>
              {isSmall ? (
                <>
                  <span style={{ display: "block" }}>THE</span>
                  <span style={{ display: "block" }}>TROPICAL</span>
                  <span style={{ display: "block" }}>SUITE</span>
                </>
              ) : (
                "THE TROPICAL SUITE"
              )}
            </Typography>
            <Box sx={styles.textWrapper2}>
              <Typography sx={styles.subheading}>
                A vibrant retreat with lush greenery and breezy interiors, perfect for refreshing stay
              </Typography>
            </Box>
          </Box>
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <HoverButton
              onClick={() => navigate("/the-tropical-suite")}
              width={isMobileSmall ? "130px" : "180px"}
              height={isMobileSmall ? "40px" : "50px"}
              endIcon={
                <img
                  src={EastIconArrow}
                  alt="east"
                  style={{
                    width: isMobileSmall ? "20px" : "25px",
                    height: isMobileSmall ? "20px" : "25px",
                    transform: "rotate(-50deg)",
                  }}
                />
              }
              btnText={"View the Suite"}
              sx={{
                fontSize: isMobileSmall ? "12px" : "14px",
              }}
            />
          </Box>
        </Box>

        <Box sx={styles.suiteCard}>
          <Box sx={styles.imageContainer}>
            <img src={suiteImage2} alt="Suite 1" style={styles.image} />
          </Box>
          <Box sx={styles.textWrapper}>
            <Typography sx={styles.title}>
              {isSmall ? (
                <>
                  <span style={{ display: "block" }}>THE</span>
                  <span style={{ display: "block" }}>EARTHEN</span>
                  <span style={{ display: "block" }}>SUITE</span>
                </>
              ) : (
                "THE EARTHEN SUITE"
              )}
            </Typography>
            <Box sx={styles.textWrapper2}>
              <Typography sx={styles.subheading}>
                Inspired by nature, featuring rustic textures and calming neutral tones.
              </Typography>
            </Box>
          </Box>
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <HoverButton
              onClick={() => navigate("/the-earthen-suite")}
              width={isMobileSmall ? "130px" : "180px"}
              height={isMobileSmall ? "40px" : "50px"}
              endIcon={
                <img
                  src={EastIconArrow}
                  alt="east"
                  style={{
                    width: isMobileSmall ? "20px" : "25px",
                    height: isMobileSmall ? "20px" : "25px",
                    transform: "rotate(-50deg)",
                  }}
                />
              }
              btnText={"View the Suite"}
              sx={{
                fontSize: isMobileSmall ? "12px" : "14px",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AmberOtherSuites;
